if (!window.Eurus.loadedScript.has('search-prompts.js')) {
    window.Eurus.loadedScript.add('search-prompts.js');

    requestAnimationFrame(() => {
      document.addEventListener("alpine:init", () => {
        Alpine.data('xSearchPrompts', (
          element,
          searchPrompts,
          enableOnMobile
        ) => ({
          buildPlaceholder(prompts) {
            if (prompts.length === 1) {
              return prompts[0];
            }

            const words = prompts.map(prompt => prompt.split(' '));
            let prefixLength = 0;
            while (
              words.every(parts => prefixLength < parts.length - 1 && parts[prefixLength] === words[0][prefixLength])
            ) {
              prefixLength++;
            }

            const prefix = words[0].slice(0, prefixLength).join(' ');
            const terms = words.map(parts => parts.slice(prefixLength).join(' '));

            return (prefix ? prefix + ' ' : '') + terms.join(', ');
          },

          init() {
            if (window.matchMedia("(max-width: 768px)").matches && !enableOnMobile) {
              return;
            }
            const nonEmptyPrompts = searchPrompts.map(prompt => prompt.trim()).filter(prompt => prompt !== '');

            if (nonEmptyPrompts.length === 0) {
              return;
            }

            element.placeholder = this.buildPlaceholder(nonEmptyPrompts);
          }
        }))
      });
    });
  }
